export default {
  s: '%d giây',
  smicro: '%d s',
  smid: '%d giây',

  ss: '%d giây',
  ssmicro: '%d s',
  ssmid: '%d giây',

  m: '%d phút',
  mmicro: '%d p',
  mmid: '%d phút',

  mm: '%d phút',
  mmmicro: '%d p',
  mmmid: '%d phút',

  h: '%d giờ',
  hmicro: '%d h',
  hmid: '%d giờ',

  hh: '%d giờ',
  hhmicro: '%d h',
  hhmid: '%d giờ',

  d: '%d ngày',
  dmicro: '%d n',
  dmid: '%d ngày',

  dd: '%d ngày',
  ddmicro: '%d n',
  ddmid: '%d ngày',
};
